export const mergeParams = (a: URLSearchParams, b: URLSearchParams) => {
  const out = new URLSearchParams(a);
  for (const [k, v] of b) {out.set(k, v);}
  return out;
};
